/*
		chosenmultiselect.js
			Code for large multiselect controls

	To simplify the usage of this class there are some requirements set in stone:
		* list is an array of entities where list[n][0] is the value as output for the form submission
		* list[n][1] is the textual name to be displayed in the drop down
		* Assigned must be an array that corresponds to the form value list[n][1]
		*
	For usablility the
 */

var Class = require('./class.js');
var DOM = require('./dom.js');
var FontMetrics = require('./fontmetrics.js');
var Browser = require('./browser.js');
var Ajax = require('./ajax.js');
var Event = require('./event.js');


var ChosenMultiselect = module.exports = Class(null, {
	__init__: function(container, formname, list, assigned) {
		this.metrics = new FontMetrics({'font': '14px arial'});
		this.container = container;
		this.available = list.sort(this.sortAlpha);
		this.assigned = assigned;
		this.selections = {};
		this.visselections = [];
		this.selected = -1;
		this.observing = true;
		this.container.style.width = '450px';
		this.selectBox = DOM.style({'display': 'None'}, DOM.SELECT({'multiple': true, 'name': formname}));
		this.txtSearch = DOM.LI({'className': 'search-field'}, this.txtInput = DOM.INPUT({'name': 'ignore', 'type': 'text', 'autocomplete': 'off'}));

		this.selectedUL = DOM.UL({'className': 'multi-choices'}, '');

		DOM.addNodes(this.selectedUL, this.txtSearch);

		this.dropSelect = DOM.style({'display': 'none'}, DOM.DIV({'className': 'drop-select'}, this.optionContainer = DOM.UL(null, '')));
		for(var i = 0; i < list.length; i++){
			var li = new SelectableLI(list[i][1], i, this.addSelected.bind(this), this.updateSelected.bind(this));
			this.selections[i] = li;
			this.visselections.push(li);
			var opt = DOM.OPTION({'value': list[i][0], 'data-option-array-index': i}, list[i][1]);
			DOM.addNodes(this.selectBox, opt);
			DOM.addNodes(this.optionContainer, li);
			li.__element__.className = 'active-result';

			if(assigned.indexOf(list[i][0]) != -1){
				li.onclick();
				opt.selected = true;
			}
		}

		DOM.addNodes(this.container, this.selectedUL, this.dropSelect, this.selectBox);
		Event.observe(this.txtInput, 'focus', this, this.onTxtFocus.bind(this));
		Event.observe(this.txtInput, 'blur', this, this.onTxtLostFocus.bind(this));
		Event.observe(this.txtInput, 'keyup', this, this.onTxtChange.bind(this));
		Event.observe(this.txtInput, 'keydown', this, this.onKeyDown.bind(this));
		Event.observe(this.selectedUL, 'click', this, function(evt) {
				this.txtInput.focus();
			}.bind(this));
	},

	sortAlpha: function(a, b){
		if(a[1] == b[1])
			return 0;
		else if(a[1] > b[1])
			return 1;
		else
			return -1;
	},

	onKeyDown: function(evt){
		if(evt.keyCode == 9)
			DOM.hide(this.dropSelect);
		else if(evt.keyCode == 13)
			Event.stop(evt);
	},

	onTxtChange: function(evt){
		var keys = Object.keys(this.selections);

		switch(evt.keyCode){
			case 13:
				if(this.selected >= 0)
					this.selections[this.selected].onclick();
				Event.stop(evt);
				break;
			case 27:
				DOM.hide(this.dropSelect);
				if(this.selected >= 0){
					this.selections[this.selected].onMouseOut();
					this.selected = -1;
				}
				break;
			case 38:
				DOM.show(this.dropSelect);
				if(this.selected >= 0)
					this.selections[this.selected].onMouseOut();

				for(var i = this.visselections.length -1; i >= 0; i--){
					if(this.visselections[i].arrayIndex >= this.selected)
						continue;
					if(this.selections[i].__element__.className.indexOf('active-result') != -1){
						this.selected = this.visselections[i].arrayIndex;
						this.visselections[i].onMouseOver();
						this.visselections[i].__element__.scrollIntoView(true);
						break;
					}
				}
				break;
			case 40:
				DOM.show(this.dropSelect);
				if(this.selected >= 0)
					this.selections[this.selected].onMouseOut();

				for(var i=0; i<this.visselections.length; i++){
					if(this.visselections[i].arrayIndex <= this.selected)
						continue;

					if(this.visselections[i].__element__.className.indexOf('active-result') != -1){
						this.selected = this.visselections[i].arrayIndex;
						this.visselections[i].__element__. scrollIntoView(true);
						this.visselections[i].onMouseOver();
						break;
					}
				}
				break;
			default:
				this.visselections = [];
				this.selected = -1;
				for(var i = 0; i < keys.length; i++){
					var entry = this.selections[keys[i]];
					DOM.removeClassName(entry.__element__, 'hovered');
					if(entry.txt.toLowerCase().indexOf(this.txtInput.value.toLowerCase()) == -1 && this.txtInput.value != '')
						DOM.hide(entry.__element__);
					else{
						this.visselections.push(entry);
						DOM.show(entry.__element__);
					}
				}
				var width = Math.max(25, this.metrics.calcMetrics(this.txtInput.value) + 20);
				this.txtInput.style.width = width + 'px';
				break;
		}
	},

	onTxtFocus: function(evt){
		if(this.selectedUL.className.indexOf('multichoice-container-active') == -1);
			this.selectedUL.className += ' multichoice-container-active';
		DOM.show(this.dropSelect);
		Event.observe(window, 'click', this, this.onWindowClick.bind(this));
		this.observing = true;
// 		this.lastfocus = evt.timeStamp;
	},

	onWindowClick: function(evt){
		this.selected = -1;
		var target = (evt.target) ? evt.target : evt.srcElement;
		if(!DOM.isParent(this.container, target))
			DOM.hide(this.dropSelect);
		if(this.observing)
			Event.stopObserving(window, 'click', this);
	},

	onTxtLostFocus: function(evt){
		this.selected = -1;
		idx = this.selectedUL.className.indexOf('multichoice-container-active')
		if(idx != -1);
			this.selectedUL.className = this.selectedUL.className.substring(0, idx -1);
// 		this.lostfocus = evt.timeStamp
// 		window.setTimeout(method(this, function(evt){if(this.lostfocus - this.lastfocus > 100) DOM.hide(this.dropSelect);}), 200);
	},

	addSelectedById: function(toselect){
		for(var i = 0; i < this.available.length; i++){
			if(toselect == this.available[i][0]){
				this.selections[i].onclick();
				break;
			}
		}
	},

	addSelected: function(arrayIndex){
		this.selected = -1;
		var toInsert = new MultiSelected(this.selections[arrayIndex].txt, arrayIndex, this.removeSelected.bind(this));
		this.selectBox.options[arrayIndex].selected = true;
		DOM.addBefore(this.selectedUL, this.txtSearch, toInsert);
		DOM.hide(this.dropSelect);
	},

	removeSelected: function(elem){
		this.selected = -1;
		this.selectBox.options[elem.arrayIndex].selected = false;
		DOM.removeNodes(this.selectedUL, elem);
		this.selections[elem.arrayIndex].returned();
		DOM.hide(this.dropSelect);
		if(this.observing)
			Event.stopObserving(window, 'click', this);
	},

	updateSelected: function(arrayIndex){
		if(this.selected > 0)
			this.selections[this.selected].onMouseOut();
		this.selected = arrayIndex;
	}
});

var MultiSelected = Class(null, {
	__init__: function(txt, arrayIndex, closecb){
		this.arrayIndex = arrayIndex;
		this.closecb = closecb;
		this.txt = txt;
		this.__element__ = DOM.LI({'className': 'searchChoice'}, DOM.SPAN(null, txt), this.closebtn = png.load('/bubble/close.png', 12, 12, {'className': 'multi-closebtn'}));
		Event.observe(this.closebtn, 'click', this, this.closing.bind(this));
	},

	closing: function(evt){
		Event.stop(evt);
		this.closecb(this);
	}
})

var SelectableLI = Class(null, {
	__init__: function(txt, arrayIndex, clickCb, moCb){
		this.txt = txt;
		this.arrayIndex = arrayIndex;
		this.clickCb = clickCb;
		this.moCb = moCb;
		this.__element__ = DOM.LI({'className': 'selectable-li'}, txt);
		Event.observe(this.__element__, 'mouseover', this, this.onMouseOver.bind(this));
		Event.observe(this.__element__, 'mouseout', this, this.onMouseOut.bind(this));
		Event.observe(this.__element__, 'click', this, this.onclick.bind(this));
	},

	onMouseOut: function(evt){
		if(this.__element__.className.indexOf('active-result') != -1){
			DOM.removeClassName(this.__element__, 'hovered');
			if(evt)
				this.moCb(-1);
		}
//	 			if(this.__element__.classList.contains('active-result'))
	},

	onMouseOver: function(evt){
		if(this.__element__.className.indexOf('active-result') != -1){
			DOM.addClassName(this.__element__, 'hovered');
			if(evt)
				this.moCb(this.arrayIndex);
		}
	},

	returned: function(evt){
		this.__element__.className = 'active-result';
	},


	onclick: function(evt){
		if(this.__element__.className.indexOf('active-result') != -1){
			this.__element__.className = 'result-selected';
			this.clickCb(this.arrayIndex);
		}
	}
})
